import { strings } from "validations";
import * as yup from "yup";

export const blogsSchema = yup
  .object({
    title: yup.string().required(strings("").required),
    time: yup.string(),
    alt: yup.string(),
    blog_category_id: yup.string().required(strings("").required),

  })
  .required();

  export default blogsSchema